import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * A lista dedicada RD Equipamentos foi retirada: propostas/apólices RD agora
 * aparecem nas listas unificadas (Cotações/Propostas/Apólices) via filtro de
 * produto. Este arquivo permanece apenas como uma rota de REDIRECT (sem UI):
 * sem ele, `/quotes/rd-equipamentos` cairia na rota dinâmica irmã de detalhe
 * de cotação (`$id`), que trataria `rd-equipamentos` como um id e renderizaria
 * uma tela de detalhe quebrada. O redirect leva o deep-link antigo para a
 * lista unificada de Cotações.
 */
export const Route = createFileRoute('/_app/quotes/rd-equipamentos/')({
  beforeLoad: () => {
    throw redirect({ to: '/quotes' });
  },
});
